
import React from "react";
import { DollarSign, CreditCard, ShieldCheck } from "lucide-react";
import {
  Accordion
} from "@/components/ui/accordion";
import FAQItem from "./FAQItem";

const FinancialProtectionFAQ = () => {
  return (
    <div className="mb-8">
      <h3 className="text-xl font-semibold mb-4 theme-primary-text flex items-center">
        <DollarSign className="h-5 w-5 mr-2" />
        Phí Dịch Vụ & Tài Chính
      </h3>
      <Accordion type="single" collapsible className="space-y-4" defaultValue="item-0">
        <FAQItem
          value="item-0"
          icon={DollarSign}
          question="Dịch vụ quản lý cho thuê của Propico hoạt động như thế nào?"
          answer="Propico quản lý trọn gói từ A-Z: tìm khách, sàng lọc, ký hợp đồng, thu tiền hộ, bảo trì và báo cáo tài chính minh bạch hàng tháng. Phí dịch vụ chỉ từ 8% tiền thuê thực thu — bạn chỉ trả khi có khách thuê. Không phí ẩn, không cam kết dài hạn bắt buộc."
        />
        <FAQItem
          value="item-1"
          icon={CreditCard}
          question="Phí dịch vụ được tính như thế nào?"
          answer="Phí quản lý được tính trên phần trăm tiền thuê thực thu: Gói Standard 8%, Gói Premium 15%. Bạn chỉ trả phí khi có khách thuê — nếu căn hộ trống, bạn không phải trả phí quản lý. Mọi chi phí đều được thể hiện rõ ràng trong hợp đồng dịch vụ."
        />
        <FAQItem
          value="item-2"
          icon={ShieldCheck}
          question="Propico quản lý tiền thuê như thế nào?"
          answer="Propico thu tiền thuê hộ chủ nhà, chuyển trả đúng hạn và gửi báo cáo tài chính chi tiết mỗi tháng. Mọi giao dịch đều minh bạch, có hóa đơn và chứng từ rõ ràng. Hợp đồng dịch vụ có hiệu lực pháp lý với điều khoản trách nhiệm các bên được quy định cụ thể."
        />
      </Accordion>
    </div>
  );
};

export default FinancialProtectionFAQ;
